import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { VisualizationCanvasElementGitService } from './visualization-canvas-element-git.service';

@Injectable({ providedIn: 'root' })
export class VisualizationCanvasElementGitFactoryService extends AbstractGitFactoryService<VisualizationCanvasElementGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: VisualizationCanvasElementGitService,
    });
  }
}
